import { JOURNEY_ARTISAN_SUPPORT_CONTENT } from '../constants/journeyArtisanSupportContent'

function BulletList({ items }) {
  return (
    <ul className="list-none space-y-4 sm:space-y-5 pl-0 mt-4">
      {items.map((text, i) => (
        <li key={i} className="flex gap-3 font-poppinsLight text-[15px] sm:text-base leading-relaxed text-neutral-800">
          <span className="mt-[0.55em] h-1 w-1 flex-shrink-0 rounded-full bg-black" aria-hidden />
          <span>{text}</span>
        </li>
      ))}
    </ul>
  )
}

const JourneyArtisanSupportWelcomePack = () => {
  const c = JOURNEY_ARTISAN_SUPPORT_CONTENT

  return (
    <div className="text-black">
      <header className="text-center space-y-4 sm:space-y-5 mb-10 sm:mb-12 max-w-3xl mx-auto">
        <p className="font-AXONALLPrimeMedium text-[11px] sm:text-xs uppercase tracking-[0.28em] text-neutral-600">
          {c.brand}
        </p>
        <h2 className="font-poppinsSemiBold text-xl sm:text-2xl md:text-[1.65rem] text-black leading-snug tracking-tight text-balance">
          {c.headline}
        </h2>
        <p className="font-poppinsRegular italic text-[15px] sm:text-base text-neutral-700 max-w-2xl mx-auto leading-relaxed">
          {c.intro}
        </p>
      </header>

      <div className="border border-black bg-neutral-200/35 px-5 py-5 sm:px-7 sm:py-6 mb-12 sm:mb-14 space-y-4">
        <p className="font-poppinsLight text-[15px] sm:text-base leading-relaxed text-neutral-900 text-left">
          {c.callout.primary}
        </p>
        <p className="font-poppinsSemiBold text-[15px] sm:text-base leading-relaxed text-black text-left">
          {c.callout.emphasis}
        </p>
      </div>

      <section className="mb-12 sm:mb-14">
        <h3 className="font-AXONALLPrimeSemiBold text-lg sm:text-xl text-black tracking-tight">
          {c.studioAccess.title}
        </h3>
        <BulletList items={c.studioAccess.bullets} />
      </section>

      <section>
        <h3 className="font-AXONALLPrimeSemiBold text-lg sm:text-xl text-black tracking-tight">
          {c.artisanSupport.title}
        </h3>
        <BulletList items={c.artisanSupport.bullets} />
        <p className="mt-8 font-poppinsSemiBold text-[15px] sm:text-base text-black leading-relaxed">
          {c.artisanSupport.footnote}
        </p>
      </section>
    </div>
  )
}

export default JourneyArtisanSupportWelcomePack
